import { fetch } from '../'

export default {
  async add_user (email) {
    const fd = new FormData()
    fd.append('email', email)

    let response = await fetch(`/wp-json/wpvue/v1/brevo/${window.lang ? '?lang=' + window.lang : ''}`, {
      method: 'POST',
      body: fd
    })
    let data = await response.json()
    return response.ok ? data : []
  }
}
